import { DeviceVm } from "./device.vm";

export class GetDeviceVm extends DeviceVm { }